import { bizgainOnboardingRoutes } from '../constants';
const AgeGenderTarget = () => import(/* webpackChunkName: "section3" */ 'Features/bizgainOnboarding/pages/ageGenderTarget/Main');
const LocationTargeting = () => import(/* webpackChunkName: "section3" */ 'Features/bizgainOnboarding/pages/locationTargeting/Main');
const Budget = () => import(/* webpackChunkName: "section3" */ 'Features/bizgainOnboarding/pages/budget/Main');
const LinkAccounts = () => import(/* webpackChunkName: "section3" */ 'Features/bizgainOnboarding/pages/linkAccounts/Main');
const LaunchAnimation = () => import(/* webpackChunkName: "section3" */ 'Features/bizgainOnboarding/pages/launch/Main');
const CreativeAnimation = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/creativeAnimation/Main');
const AdAccountSetupAnimation = () => import(/* webpackChunkName: "section3" */ 'Features/bizgainOnboarding/pages/adAccountSetupAnimation/Main');
// Keeping prefetch disabled. Using vuejs magic hint (webpackPrefetch: true) to accommodate prefetch selectively
// This ensures only section1 related chunks have a prefetch hint
const BizgainOnboarding = () => import(/* webpackPrefetch: true, webpackChunkName: "section1" */ 'Features/bizgainOnboarding/Main');
const ImageCreatives = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/imageCreatives/Main');
const ImageCreativesCreativePreview = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/imageCreativesCreativePreview/Main');
const ImageCreativesCreativeEdit = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/imageCreativesCreativeEdit/Main');
const ImageCreativesAdPreview = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/imageCreativesAdPreview/Main');
const ImageCreativesAdDetailsEdit = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/imageCreativesAdDetailsEdit/Main');
const GoogleAdsPreview = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/googleAdsPreview/Main');
const GoogleAdsEdit = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/googleAdsEdit/Main');
const ExtractBusinessDetails = () => import(/* webpackChunkName: "section1" */ 'Features/bizgainOnboarding/pages/businessDetails/components/ExtractBusinessDetails');
const BusinessTypeServices = () => import(/* webpackChunkName: "section1" */ 'Features/bizgainOnboarding/pages/businessTypeServices/Main');
const SelectGender = () => import(/* webpackChunkName: "section3" */ 'Features/bizgainOnboarding/pages/SelectGender/Main');
const BusinessLocationDetails = () => import(/* webpackChunkName: "section1" */ 'Features/bizgainOnboarding/pages/businessLocationDetails/Main');
const ExtractOfferDetails = () => import(/* webpackChunkName: "section1" */ 'Features/bizgainOnboarding/pages/offerDetails/Main');
const EmailSignup = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/emailSignup/Main');
const PromoteServices = () => import(/* webpackChunkName: "section1" */ 'Features/bizgainOnboarding/pages/promoteServices/Main');
const SelectObjective = () => import(/* webpackChunkName: "section1" */ 'Features/bizgainOnboarding/pages/SelectObjective/Main');
const Confirmation = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/confirmation/Main');
const BusinessPhoneNumber = () => import(/* webpackChunkName: "section1" */ 'Features/bizgainOnboarding/pages/businessPhoneNumber/Main');
const BusinessDetailsAnimation = () => import(/* webpackChunkName: "section1" */ 'Features/bizgainOnboarding/pages/businessDetailsAnimation/Main');
const SummaryDetails = () => import(/* webpackChunkName: "section1" */ 'Features/bizgainOnboarding/pages/Summary/Main');
//const SummaryLink = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/SummaryLink/Main');
const BusinessDetailsSetupAnimation = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/businessDetailsSetupAnimation/Main');
//import component for shorten flow
const SetupBusinessInfo = () => import(/* webpackChunkName: "section1" */ 'Features/bizgainOnboarding/pages/businessDetails/components/SetupBusinessInfo');
const BusinessDetailsV2 = () => import(/* webpackChunkName: "section1" */ 'Features/bizgainOnboarding/pages/businessDetails/components/BusinessDetailsV2');
const BusinessDetailsSetupAnimationV2 = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/businessDetailsSetupAnimation/BusinessDetailsSetupAnimationV2');
const CreativeDetailsV2 = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/imageCreativesAdPreview/components/CreativeDetailsPreviewV2');
const Targeting = () => import(/* webpackChunkName: "section2" */ 'Features/bizgainOnboarding/pages/targeting/Main');
const FacebookInterests = () => import(/* webpackChunkName: "section3" */ 'Features/bizgainOnboarding/pages/facebookInterests/FacebookInterests.vue');
const GoogleKeywords = () => import(/* webpackChunkName: "section3" */ 'Features/bizgainOnboarding/pages/googleKeywords/GoogleKeywords.vue');
const ChannelSelection = () => import(/* webpackChunkName: "section3" */ 'Features/bizgainOnboarding/pages/channelSelection/ChannelSelection.vue');

export const BizgainOnboardingRoutes = Object.freeze([
  {
    name: bizgainOnboardingRoutes.bizgain.name,
    path: bizgainOnboardingRoutes.bizgain.path,
    component: BizgainOnboarding,
    meta: {
      requiresAuth: false,
      bizgainLayout: true
    },
    children: [
      {
        name: bizgainOnboardingRoutes.RouteConfirmation.name,
        path: bizgainOnboardingRoutes.RouteConfirmation.path,
        component: Confirmation,
        meta: {
          requiresAuth: false,
          isStatusLayout: true,
          bizgainLayout: true
        }
      },
      {
        name: bizgainOnboardingRoutes.ExtractBusinessDetails.name,
        path: bizgainOnboardingRoutes.ExtractBusinessDetails.path,
        component: ExtractBusinessDetails,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.ExtractBusinessDetails.helpText,
          stepNumber: 1,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.ExtractBusinessDetails.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.BusinessDetailsSetupAnimation.name,
        path: bizgainOnboardingRoutes.BusinessDetailsSetupAnimation.path,
        component: BusinessDetailsSetupAnimation,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          stepNumber: 1,
          stepCount: 6,
          isBackButtonDisabled: true,
          helpText: bizgainOnboardingRoutes.BusinessLocationDetails.helpText,
          animationPath: bizgainOnboardingRoutes.BusinessLocationDetails.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.BusinessLocationDetails.name,
        path: bizgainOnboardingRoutes.BusinessLocationDetails.path,
        component: BusinessLocationDetails,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.BusinessLocationDetails.helpText,
          backButtonRoute: bizgainOnboardingRoutes.ExtractBusinessDetails.name,
          stepNumber: 1,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.BusinessLocationDetails.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.BusinessTypeServices.name,
        path: bizgainOnboardingRoutes.BusinessTypeServices.path,
        component: BusinessTypeServices,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.BusinessTypeServices.helpText,
          backButtonRoute: bizgainOnboardingRoutes.BusinessLocationDetails.name,
          stepNumber: 1,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.BusinessTypeServices.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SelectGender.name,
        path: bizgainOnboardingRoutes.SelectGender.path,
        component: SelectGender,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SelectGender.helpText,
          backButtonRoute: bizgainOnboardingRoutes.BusinessTypeServices.name,
          stepNumber: 1,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.SelectGender.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SelectObjective.name,
        path: bizgainOnboardingRoutes.SelectObjective.path,
        component: SelectObjective,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SelectObjective.helpText,
          backButtonRoute: bizgainOnboardingRoutes.BusinessLocationDetails.name,
          stepNumber: 2,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.SelectObjective.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.PromoteServices.name,
        path: bizgainOnboardingRoutes.PromoteServices.path,
        component: PromoteServices,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.PromoteServices.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SelectObjective.name,
          stepNumber: 2,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.PromoteServices.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.ExtractOfferDetails.name,
        path: bizgainOnboardingRoutes.ExtractOfferDetails.path,
        component: ExtractOfferDetails,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.ExtractOfferDetails.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SelectObjective.name,
          stepNumber: 3,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.ExtractOfferDetails.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.ImageCreatives.name,
        path: bizgainOnboardingRoutes.ImageCreatives.path,
        component: ImageCreatives,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.ImageCreatives.helpText,
          backButtonRoute: bizgainOnboardingRoutes.ExtractOfferDetails.name,
          stepNumber: 4,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.ImageCreatives.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.ImageCreativesCreativePreview.name,
        path: bizgainOnboardingRoutes.ImageCreativesCreativePreview.path,
        component: ImageCreativesCreativePreview,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.ImageCreativesCreativePreview.helpText,
          backButtonRoute: bizgainOnboardingRoutes.ImageCreatives.name,
          stepNumber: 4,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.ImageCreativesCreativePreview.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.ImageCreativesCreativeEdit.name,
        path: bizgainOnboardingRoutes.ImageCreativesCreativeEdit.path,
        component: ImageCreativesCreativeEdit,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.ImageCreativesCreativeEdit.helpText,
          backButtonRoute: bizgainOnboardingRoutes.ImageCreativesCreativePreview.name,
          stepNumber: 4,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.ImageCreativesCreativeEdit.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.ImageCreativesAdPreview.name,
        path: bizgainOnboardingRoutes.ImageCreativesAdPreview.path,
        component: ImageCreativesAdPreview,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.ImageCreativesAdPreview.helpText,
          backButtonRoute: bizgainOnboardingRoutes.ImageCreativesCreativePreview.name,
          stepNumber: 4,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.ImageCreativesAdPreview.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.name,
        path: bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.path,
        component: ImageCreativesAdDetailsEdit,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.helpText,
          backButtonRoute: bizgainOnboardingRoutes.ImageCreativesAdPreview.name,
          stepNumber: 4,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.GoogleAds.name,
        path: bizgainOnboardingRoutes.GoogleAds.path,
        component: GoogleAdsPreview,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.GoogleAds.helpText,
          backButtonRoute: bizgainOnboardingRoutes.ImageCreativesAdPreview.name,
          stepNumber: 5,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.GoogleAds.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.GoogleAdsEdit.name,
        path: bizgainOnboardingRoutes.GoogleAdsEdit.path,
        component: GoogleAdsEdit,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.GoogleAdsEdit.helpText,
          backButtonRoute: bizgainOnboardingRoutes.GoogleAds.name,
          stepNumber: 5,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.GoogleAdsEdit.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.EmailSignup.name,
        path: bizgainOnboardingRoutes.EmailSignup.path,
        component: EmailSignup,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.EmailSignup.helpText,
          backButtonRoute: bizgainOnboardingRoutes.GoogleAds.name,
          stepNumber: 6,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.EmailSignup.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.AgeGenderTarget.name,
        path: bizgainOnboardingRoutes.AgeGenderTarget.path,
        component: AgeGenderTarget,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          stepNumber: 6,
          stepCount: 6,
          helpText: bizgainOnboardingRoutes.AgeGenderTarget.helpText,
          animationPath: bizgainOnboardingRoutes.AgeGenderTarget.animationPath,
          backButtonRoute: bizgainOnboardingRoutes.GoogleAds.name
        }
      },
      {
        name: bizgainOnboardingRoutes.LocationTargeting.name,
        path: bizgainOnboardingRoutes.LocationTargeting.path,
        component: LocationTargeting,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          stepNumber: 6,
          stepCount: 6,
          helpText: bizgainOnboardingRoutes.LocationTargeting.helpText,
          backButtonRoute: bizgainOnboardingRoutes.AgeGenderTarget.name,
          animationPath: bizgainOnboardingRoutes.LocationTargeting.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.Budget.name,
        path: bizgainOnboardingRoutes.Budget.path,
        component: Budget,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.Budget.helpText,
          backButtonRoute: bizgainOnboardingRoutes.LocationTargeting.name,
          animationPath: bizgainOnboardingRoutes.Budget.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.BusinessPhoneNumber.name,
        path: bizgainOnboardingRoutes.BusinessPhoneNumber.path,
        component: BusinessPhoneNumber,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.BusinessPhoneNumber.helpText,
          backButtonRoute: bizgainOnboardingRoutes.BusinessLocationDetails.name,
          stepNumber: 1,
          stepCount: 6,
          animationPath: bizgainOnboardingRoutes.BusinessPhoneNumber.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.BusinessDetailsAnimation.name,
        path: bizgainOnboardingRoutes.BusinessDetailsAnimation.path,
        component: BusinessDetailsAnimation,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          isStatusLayout: true,
          animationPath: bizgainOnboardingRoutes.BusinessDetailsAnimation.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.CreativeAnimation.name,
        path: bizgainOnboardingRoutes.CreativeAnimation.path,
        component: CreativeAnimation,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          isStatusLayout: true,
          animationPath: bizgainOnboardingRoutes.CreativeAnimation.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.Summary.name,
        path: bizgainOnboardingRoutes.Summary.path,
        component: SummaryDetails,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          animationPath: bizgainOnboardingRoutes.Summary.animationPath,
          hideHeader: true
        }
      },
      // {
      //   name: bizgainOnboardingRoutes.SummaryLink.name,
      //   path: bizgainOnboardingRoutes.SummaryLink.path,
      //   component: SummaryLink,
      //   meta: {
      //     requiresAuth: false,
      //     bizgainLayout: true,
      //     animationPath: bizgainOnboardingRoutes.SummaryLink.animationPath
      //   }
      // }

      //added ruote for ai website crawl flow
      {
        name: bizgainOnboardingRoutes.SetupBusinessInfo.name,
        path: bizgainOnboardingRoutes.SetupBusinessInfo.path,
        component: SetupBusinessInfo,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SetupBusinessInfo.helpText,
          stepNumber: 1,
          stepCount: 3,
          animationPath: bizgainOnboardingRoutes.SetupBusinessInfo.animationPath
        }
      },

      // added route for shorten flow
      {
        name: bizgainOnboardingRoutes.BusinessDetailsV2.name,
        path: bizgainOnboardingRoutes.BusinessDetailsV2.path,
        component: BusinessDetailsV2,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.ExtractBusinessDetails.helpText,
          stepNumber: 1,
          stepCount: 3,
          animationPath: bizgainOnboardingRoutes.ExtractBusinessDetails.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.BusinessDetailsSetupAnimationV2.name,
        path: bizgainOnboardingRoutes.BusinessDetailsSetupAnimationV2.path,
        component: BusinessDetailsSetupAnimationV2,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          stepNumber: 1,
          stepCount: 3,
          isBackButtonDisabled: true,
          helpText: bizgainOnboardingRoutes.BusinessLocationDetails.helpText,
          animationPath: bizgainOnboardingRoutes.BusinessLocationDetails.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.CreativeDetailsV2.name,
        path: bizgainOnboardingRoutes.CreativeDetailsV2.path,
        component: CreativeDetailsV2,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.ImageCreativesAdPreview.helpText,
          backButtonRoute: bizgainOnboardingRoutes.BusinessDetailsV2.name,
          stepNumber: 2,
          stepCount: 3,
          animationPath: bizgainOnboardingRoutes.ImageCreativesAdPreview.animationPath
        }
      }
    ]
  }
])

export const BizgainOnboardingAppRoutes = Object.freeze([
  {
    name: bizgainOnboardingRoutes.campaign.name,
    path: bizgainOnboardingRoutes.campaign.path,
    component: BizgainOnboarding,
    meta: {
      requiresAuth: true,
      bizgainLayout: true
    },
    children: [
      {
        name: bizgainOnboardingRoutes.SubsequentSelectObjective.name,
        path: bizgainOnboardingRoutes.SubsequentSelectObjective.path,
        component: SelectObjective,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentSelectObjective.helpText,
          animationPath: bizgainOnboardingRoutes.SubsequentSelectObjective.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentPromoteServices.name,
        path: bizgainOnboardingRoutes.SubsequentPromoteServices.path,
        component: PromoteServices,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentPromoteServices.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentSelectObjective.name,
          animationPath: bizgainOnboardingRoutes.SubsequentPromoteServices.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentExtractOfferDetails.name,
        path: bizgainOnboardingRoutes.SubsequentExtractOfferDetails.path,
        component: ExtractOfferDetails,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentExtractOfferDetails.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentSelectObjective.name,
          animationPath: bizgainOnboardingRoutes.SubsequentExtractOfferDetails.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentImageCreatives.name,
        path: bizgainOnboardingRoutes.SubsequentImageCreatives.path,
        component: ImageCreatives,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentImageCreatives.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentExtractOfferDetails.name,
          animationPath: bizgainOnboardingRoutes.SubsequentImageCreatives.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentImageCreativesCreativePreview.name,
        path: bizgainOnboardingRoutes.SubsequentImageCreativesCreativePreview.path,
        component: ImageCreativesCreativePreview,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentImageCreativesCreativePreview.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentImageCreatives.name,
          animationPath: bizgainOnboardingRoutes.SubsequentImageCreativesCreativePreview.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.name,
        path: bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.path,
        component: ImageCreativesCreativeEdit,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentImageCreativesCreativePreview.name,
          animationPath: bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.name,
        path: bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.path,
        component: ImageCreativesAdPreview,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentImageCreativesCreativePreview.name,
          animationPath: bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.name,
        path: bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.path,
        component: ImageCreativesAdDetailsEdit,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.name,
          animationPath: bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentGoogleAds.name,
        path: bizgainOnboardingRoutes.SubsequentGoogleAds.path,
        component: GoogleAdsPreview,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentGoogleAds.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.name,
          animationPath: bizgainOnboardingRoutes.SubsequentGoogleAds.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.name,
        path: bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.path,
        component: GoogleAdsEdit,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentGoogleAds.name,
          animationPath: bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentAgeGenderTarget.name,
        path: bizgainOnboardingRoutes.SubsequentAgeGenderTarget.path,
        component: AgeGenderTarget,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentAgeGenderTarget.helpText,
          animationPath: bizgainOnboardingRoutes.SubsequentAgeGenderTarget.animationPath,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentGoogleAds.name
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentLocationTargeting.name,
        path: bizgainOnboardingRoutes.SubsequentLocationTargeting.path,
        component: LocationTargeting,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentLocationTargeting.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentAgeGenderTarget.name,
          animationPath: bizgainOnboardingRoutes.SubsequentLocationTargeting.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.LinkAccounts.name,
        path: bizgainOnboardingRoutes.LinkAccounts.path,
        component: LinkAccounts,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.LinkAccounts.helpText,
          isBackButtonDisabled: true,
          animationPath: bizgainOnboardingRoutes.LinkAccounts.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentBudget.name,
        path: bizgainOnboardingRoutes.SubsequentBudget.path,
        component: Budget,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentBudget.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentLocationTargeting.name,
          animationPath: bizgainOnboardingRoutes.SubsequentBudget.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.LaunchAnimation.name,
        path: bizgainOnboardingRoutes.LaunchAnimation.path,
        component: LaunchAnimation,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          isStatusLayout: true,
          animationPath: bizgainOnboardingRoutes.LaunchAnimation.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentCreativeAnimation.name,
        path: bizgainOnboardingRoutes.SubsequentCreativeAnimation.path,
        component: CreativeAnimation,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          isStatusLayout: true,
          animationPath: bizgainOnboardingRoutes.SubsequentCreativeAnimation.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.AdAccountSetupAnimation.name,
        path: bizgainOnboardingRoutes.AdAccountSetupAnimation.path,
        component: AdAccountSetupAnimation,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          isStatusLayout: false,
          isBackButtonDisabled: true,
          helpText: bizgainOnboardingRoutes.Budget.helpText,
          animationPath: bizgainOnboardingRoutes.Budget.animationPath
        }
      },
      // redirect in shorten flow after ad account animation
      {
        name: bizgainOnboardingRoutes.TargetingV2.name,
        path: bizgainOnboardingRoutes.TargetingV2.path,
        component: Targeting,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentLocationTargeting.helpText,
          backButtonRoute: bizgainOnboardingRoutes.ChannelSelection.name,
          animationPath: bizgainOnboardingRoutes.SubsequentLocationTargeting.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentBusinessDetailsV2.name,
        path: bizgainOnboardingRoutes.SubsequentBusinessDetailsV2.path,
        component: BusinessDetailsV2,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentBusinessDetailsV2.helpText,
          animationPath: bizgainOnboardingRoutes.SubsequentBusinessDetailsV2.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentBusinessDetailsSetupAnimationV2.name,
        path: bizgainOnboardingRoutes.SubsequentBusinessDetailsSetupAnimationV2.path,
        component: BusinessDetailsSetupAnimationV2,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          isBackButtonDisabled: true,
          helpText: bizgainOnboardingRoutes.SubsequentBusinessDetailsSetupAnimationV2.helpText,
          animationPath: bizgainOnboardingRoutes.SubsequentBusinessDetailsSetupAnimationV2.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.name,
        path: bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.path,
        component: CreativeDetailsV2,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.helpText,
          backButtonRoute: bizgainOnboardingRoutes.SubsequentBusinessDetailsV2.name,
          animationPath: bizgainOnboardingRoutes.ImageCreativesAdPreview.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.ChannelSelection.name,
        path: bizgainOnboardingRoutes.ChannelSelection.path,
        component: ChannelSelection,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          isBackButtonDisabled: true,
          animationPath: bizgainOnboardingRoutes.ChannelSelection.animationPath,
          helpText: bizgainOnboardingRoutes.SubsequentLocationTargeting.helpText
        }
      },
      {
        name: bizgainOnboardingRoutes.FacebookInterests.name,
        path: bizgainOnboardingRoutes.FacebookInterests.path,
        component: FacebookInterests,
        meta: {
          requiresAuth: true,
          bizgainLayout: true,
          helpText: bizgainOnboardingRoutes.FacebookInterests.helpText,
          backButtonRoute: bizgainOnboardingRoutes.ChannelSelection.name,
          animationPath: bizgainOnboardingRoutes.FacebookInterests.animationPath
        }
      },
      {
        name: bizgainOnboardingRoutes.GoogleKeywords.name,
        path: bizgainOnboardingRoutes.GoogleKeywords.path,
        component: GoogleKeywords,
        meta: {
          requiresAuth: false,
          bizgainLayout: true,
          animationPath: bizgainOnboardingRoutes.GoogleKeywords.animationPath,
          backButtonRoute: bizgainOnboardingRoutes.FacebookInterests.name
        }
      }
    ]
  }])